module.exports = __webpack_public_path__ + "img/colorBox6.d68d4108.jpg";